import React from "react";
import { cn } from "../../lib/utils";

const variants = {
  default: "bg-foreground text-background hover:bg-foreground/90",
  primary: "bg-accent text-black hover:bg-accent/90 font-semibold",
  outline: "border border-border bg-transparent hover:bg-surface text-foreground",
  ghost: "bg-transparent hover:bg-surface text-foreground",
  destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  link: "underline-offset-4 hover:underline text-foreground p-0 h-auto",
};

const sizes = {
  default: "h-10 px-4 text-sm",
  sm: "h-8 px-3 text-xs",
  lg: "h-12 px-6 text-base",
  icon: "h-10 w-10",
};

export const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", asChild, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center gap-2 rounded-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";
